<template>
	<div class="EditDeleteHistSales">
		<el-row :gutter="20" class="top-margin">
			<el-col :xl="6" :lg="6" :md="6" :sm="12" :xs="24">
				<label>Select Store Location for Edit</label>
				<el-select
					v-model="value"
					class="custom-input"
					style="width: 100%;"
					:disabled="checked == 'all'"
					multiple
					collapse-tags
					placeholder="Select Location"
				>
					<el-option
						v-for="outlet in 5"
						:key="outlet"
						:label="outlet"
						value="outlet"
					/>
				</el-select>
			</el-col>
			<el-col :xl="8" :lg="8" :md="8" :sm="12" :xs="24">
				<div class="if-not mt-6">
					<a
						href="https://s3.ap-south-1.amazonaws.com/nymbleup-public/templates/Nymble_Article_Master.csv"
					>
						<BaseButton buttonclass="btn p-2 text-xs">
							Delete Data
						</BaseButton>
					</a>
				</div>
			</el-col>
		</el-row>
		<div style="border-bottom: 1px solid #ccc; margin: 10px 0;"></div>
		<el-row :gutter="20">
			<el-col :xl="6" :lg="6" :md="6" :sm="12" :xs="24">
				<div class="custom-input">
					<BaseButton buttonclass="btn p-2">
						Download Data
					</BaseButton>
				</div>
			</el-col>
			<el-col :xl="6" :lg="6" :md="6" :sm="12" :xs="24">
				<div class="custom-input" style="display:flex;">
					<label class="btn p-2">
						Upload Edited File
						<input name="File Upload" accept=".csv" type="file" />
					</label>
				</div>
			</el-col>
			<el-col :xl="6" :lg="6" :md="6" :sm="12" :xs="24">
				<div class="custom-input">
					<BaseButton buttonclass="btn p-2">
						Finish
					</BaseButton>
				</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
import CommonService from "../../../../services/commonService";
export default {
	name: "EditDeleteHistSales",
	components: {
		// Filters
	},
	data() {
		return {
			outlets: {}
		};
	},
	created() {
		this.getOutlets();
	},
	methods: {
		getOutlets() {
			CommonService.getOutlets()
				.then(response => {
					if (response.status == 200) {
						const outlets = JSON.parse(response.data).results;
						this.outlets = outlets.reduce((acc, v) => {
							acc[v.name] = v.id;
							return acc;
						}, {});
					}
				})
				.catch(error => {
					console.log("error", error);
				});
		}
	}
};
</script>

<style scoped lang="scss">
@import "../../../../assets/css/variable.scss";
.EditDeleteHistSales {
	margin: 100px 0 40px;
	box-shadow: $app-card-shadow;
	background-color: #fff;
	padding: 1rem;
}

.EditDeleteHistSales .custom-input {
	font-size: $input-font-size;
	// height: 40px;
	margin-bottom: 20px;
	margin-top: 5px;
}
.EditDeleteHistSales label {
	color: $input-lable-color;
	font-size: $input-lable-font-size;
}
.uploadCsvInput {
	width: 190px;
	padding: 6px;
	border: 1px solid $orange-bg-button-color;
	background-color: $orange-bg-button-color;
	text-align: center;
	@extend .amp-btn;
}
.uploadCsvInput:hover {
	background-color: #fff;
	color: $orange-bg-button-color;
}
.EditDeleteHistSales .top-margin {
	margin-top: $top-margin;
}

.EditDeleteHistSales .btn input[type="file"] {
	display: none;
}
.EditDeleteHistSales .btn {
	border: 1px solid $orange-bg-button-color;
	background-color: $orange-bg-button-color;
	text-align: center;
	border-radius: 2px;
	cursor: pointer;
	letter-spacing: 0.02em;
	transition: all 0.2s ease;
	color: #fff;
	width: 100%;
	height: 100%;
	// font-size: 0.75rem;
}
.EditDeleteHistSales .btn:hover {
	background: #fff;
	color: $orange-bg-button-color;
}
</style>
